<template>
  <ul
    class="tab-max-height flex divide-x rounded-lg text-center font-medium text-gray-500"
    :class="[containerClass, disabled ? 'opacity-60' : '']"
  >
    <li
      v-for="(item, index) in items"
      :key="index"
      class="w-full"
      :class="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
      @click="selectValue(item)"
    >
      <div
        class="flex w-full items-center justify-center border-b border-t text-sm uppercase focus:outline-none focus:ring-4 focus:ring-blue-300"
        :class="[
          customClass,
          index === 0 ? 'rounded-l-md border-l' : '',
          index === items.length - 1 ? 'rounded-r-md border-r' : '',
          toggleValue === item
            ? 'active text-white ' + toggleBgClass
            : 'bg-white text-gray-over-dark',
          toggleValue !== item && !disabled ? 'hover:bg-gray-100' : '',
          size === 'lg' ? 'toogle-padding-lg w-full' : 'toogle-padding',
        ]"
      >
        <span
          :class="[
            size === 'lg'
              ? 'block w-full whitespace-nowrap text-xxs sm:text-sm'
              : '',
          ]"
        >
          {{ item }}
        </span>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ToggleButton',
  props: {
    items: {
      type: Object,
      require: true,
    },
    customClass: {
      type: String,
      default: '',
    },
    containerClass: {
      type: String,
      default: 'my-4',
    },
    initialValue: {
      type: String,
      default: '',
    },
    activeToggleBgYellow: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selectedValue'],
  data() {
    return {
      selectedValue: '',
    };
  },
  computed: {
    toggleValue: function () {
      if (this.selectedValue) {
        return this.selectedValue;
      }
      return this.initialValue || this.items[0];
    },
    toggleBgClass() {
      return this.activeToggleBgYellow ? 'bg-yellow-500' : 'bg-dark-gray';
    },
  },
  mounted() {
    this.selectedValue = this.toggleValue;
    this.emitSelectedValue();
  },
  methods: {
    emitSelectedValue() {
      this.$emit('selectedValue', this.selectedValue);
    },
    selectValue(val) {
      if (this.disabled) return;
      this.selectedValue = val;
      this.emitSelectedValue();
    },
  },
};
</script>

<style scoped>
/* Custom CSS for Checkboxes */
/* Template used from W3 schools https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_custom_checkbox */
/* The container */
.tab-max-height {
  height: max-content;
}

.toogle-padding {
  height: 53px;
  /* width: 61px; */
  padding: 12px 16px;
}
.toogle-padding-lg {
  height: 53px;
  padding: 12px 16px;
}
</style>
